import React, { useEffect, useState } from 'react';
import { getString } from '../../../app-content';
import { testAppCode } from '../../../app-auth';
import bannerImage from '../../../assets/bannerImage.png';
import elevateImage from '../../../assets/elevate.png';
import { Button, Image, Input, Popover } from '@nackle/paper';

const APP_STORAGE_KEY = 'appCode';

export default function AppCodeView( props ) {
    const { integrationType, successCallback, tenantId } = props;
    const [ appCode, setAppCode ] = useState();
    const [ appCodeHelpVisible, setAppCodeHelpVisible ] = useState( false );
    const [ appCodeInvalid, setAppCodeInvalid ] = useState( false );
    const supportLink = `https://recognition-now.biw.cloud/${ integrationType.toLowerCase() }`;

    useEffect( () => {
        if ( tenantId ) {
            //appCodeSignin( tenantId );
        }
    }, [ tenantId ] );

    const appCodeSignin = async ( tenantId ) => {
        const isAppCodeValid = await testAppCode( tenantId ? tenantId : appCode );
        if ( !isAppCodeValid ) {
            return setAppCodeInvalid( appCode ? true : false );
        }
        localStorage.setItem( APP_STORAGE_KEY, tenantId ? tenantId : appCode );
        successCallback();
    };

    return (
        <>
            <div style={ { display: 'flex', justifyContent: 'center', paddingTop: '36px', paddingBottom: '31px' } }>
                <Image preview={ false } src={ integrationType === 'TEAMS' ? elevateImage : bannerImage } alt='' />
            </div>
            <div style={ { display: 'flex', flexDirection: 'column', paddingLeft: '33px', paddingRight: '33px' } }>
                <h1 style={ { paddingBottom: '16px' } }>{ getString( 'teams.webView.appCodeHeader' ) }</h1>
                <div style={ { paddingBottom: '15px' } }>
                    <Input
                        aria-label={ getString( 'teams.webView.appCodeHeader' ) }
                        size='large'
                        placeholder={ getString( 'teams.webView.appCodePlaceholder' ) }
                        value={ appCode }
                        onChange={ ( e ) => setAppCode( e.target.value ) }
                    />
                    {
                        appCodeInvalid &&
                        <p style={ { color: 'firebrick' } }>{ getString( 'teams.webView.appCodeInvalid' ) }</p>
                    }
                </div>
                <Button
                    disabled={ !appCode }
                    onClick={ () => appCodeSignin() }
                >
                    { getString( 'teams.webView.appCodeContinue' ) }
                </Button>

                { integrationType !== 'TEAMS' && <div style={ { paddingTop: '10px' } }>
                    <Popover
                        placement='bottomLeft'
                        visible={ appCodeHelpVisible }
                        trigger='click'
                        onVisibleChange={ () => setAppCodeHelpVisible( !appCodeHelpVisible ) }
                        content={
                            <div style={ { maxWidth: '250px' } }>
                                { getString( 'teams.webView.appCodeHelp' ) }<a href={ supportLink }>{ getString( 'teams.webView.appCodeHelpSupport' ) }</a>
                            </div>
                        }
                    >
                        <a>{ getString( 'teams.webView.appCodeHelpLink' ) }</a>
                    </Popover>
                </div>
                }
            </div>
        </>
    );
}
